export default __webpack_public_path__ + "media/zurb/img/events/wired/family-giving/family-thumb-249f07034fb3d0ddcb5807043f13f4be.png";